// Copyright (c) 2017 Deere & Company

import SearchFilters from '../../../shared/state/search-filters';

export const getDefaultState = () =>
    new SearchFilters({
        filterBy: '',
        query: '',
        sortBy: ['createdDate'],
        sortDirection: 'DESC'
    });

export default SearchFilters;



// WEBPACK FOOTER //
// ./src/claim/claim-search/state/search-filters.js